function getClosestAccordion(el) {
  return el && (el.matches('[role="tablist"]') ? el : getClosestAccordion(el.parentElement));
}
function getSiblingButtons(item) {
  const parentAccordion = getClosestAccordion(item);
  return parentAccordion && Array.from(parentAccordion.querySelectorAll('[role="tab"]'));
}
function focusNextSiblingOf(item) {
  const siblings = getSiblingButtons(item) || [];
  const currentIndex = siblings.indexOf(item);
  if (currentIndex !== -1) {
    let next = siblings[currentIndex + 1];
    next = next?.hasAttribute('disabled') ? siblings[currentIndex + 2] : next;
    if (next) {
      next.focus();
    }
  }
}
function focusPreviousSiblingOf(item) {
  const siblings = getSiblingButtons(item) || [];
  const currentIndex = siblings.indexOf(item);
  if (currentIndex !== -1) {
    let previous = siblings[currentIndex - 1];
    previous = previous?.hasAttribute('disabled') ? siblings[currentIndex - 2] : previous;
    if (previous) {
      previous.focus();
    }
  }
}

export { focusNextSiblingOf, focusPreviousSiblingOf, getClosestAccordion, getSiblingButtons };
